import { combineReducers } from 'redux'
import { routerReducer as router } from 'react-router-redux'
import ui, { initialState as uiInitialState } from './ui'
import customers, { initialState as customersInitialState } from './customers'
import credentials, { initialState as credentialsInitialState } from './credentials'
import projects, { initialState as projectsInitialState } from './projects'
import auth, { initialState as authInitialState } from './auth'

export const initialState = {
  ui: uiInitialState,
  customers: customersInitialState,
  credentials: credentialsInitialState,
  projects: projectsInitialState,
  auth: authInitialState
}

export default combineReducers({
  ui,
  customers,
  credentials,
  projects,
  router,
  auth
})



// WEBPACK FOOTER //
// ./ducks/index.js